import { useQuery } from 'react-query';
import { ValidDataService } from 'service/validDataService';

const STALE_TIME = 10 * 60 * 1000; // 10 minutes — refresh if backend catalog changes

function buildLabels(types = []) {
    return types.reduce((acc, t) => {
        acc[t.key] = t.label;
        return acc;
    }, {});
}

export default function useLensTypeCatalog() {
    const { data: lensTypesData, isLoading: lensTypesLoading } = useQuery(
        ['lensTypes'],
        ValidDataService.getLensTypes,
        { staleTime: STALE_TIME }
    );

    const { data: contactLensTypesData, isLoading: contactLensTypesLoading } = useQuery(
        ['contactLensTypes'],
        ValidDataService.getContactLensTypes,
        { staleTime: STALE_TIME }
    );

    const lensTypes = lensTypesData?.data || [];
    const contactLensTypes = contactLensTypesData?.data || [];

    return {
        lensTypes,
        contactLensTypes,
        lensTypeLabels: buildLabels(lensTypes),
        contactLensTypeLabels: buildLabels(contactLensTypes),
        isLoading: lensTypesLoading || contactLensTypesLoading,
    };
}
